import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _createReducer;
import { createReducer } from '@reduxjs/toolkit';
import { ConnectionBlockActionCreator } from "../components/Container/ConnectionBlock/store/actions";
import { getExtendedBalanceList } from "../components/Container/ConnectionBlock/utils";
import { FUB_COMMON_STATUS, PAYLOAD_STATUS_DICTIONARY } from "../components/Container/ConnectionBlock/constants";
import { ActionCreator } from "./actions";
var initialState = {
  accounts: {
    data: null,
    pending: true,
    error: false
  },
  initData: {
    data: null,
    pending: true,
    error: false
  },
  commonData: {
    data: null,
    pending: true,
    error: false
  },
  notAuthData: {
    data: {
      subtitleDark: 'пополняй баланс, управляй услугами и контролируй траты - ',
      subtitleLight: 'всегда под рукой',
      icon: 'https://static.beeline.ru/upload/images/22631_dark_phone.png',
      googlePlayLink: 'https://play.google.com/store/apps/details?id=ru.beeline.services&hl=ru',
      appleLink: 'https://apps.apple.com/ru/app/moj-bilajn/id569251594',
      huaweiLink: 'https://appgallery.huawei.com/app/C100716739',
      ruStoreLink: 'https://apps.rustore.ru/app/ru.beeline.services',
      qrCode: 'https://static.beeline.ru/upload/images/22631_app_qr_code.png'
    },
    pending: true,
    error: false
  },
  notifications: {
    data: null,
    pending: true
  },
  connectionBlock: {
    mobile: {
      data: null,
      pending: true,
      error: false,
      price: {
        data: null,
        pending: true,
        error: false
      },
      power: {
        data: null,
        pending: true,
        error: false
      },
      superPower: {
        data: null,
        pending: true,
        error: false
      }
    },
    fttb: {
      pending: false,
      error: false,
      data: null
    },
    convergent: {
      pending: false,
      error: false,
      data: null
    }
  },
  uniBalance: {
    pending: true,
    error: false,
    data: null,
    balanceList: null,
    fubGroupsInfo: {
      data: {
        currentStatus: FUB_COMMON_STATUS.DENY,
        members: [],
        groupCount: 0,
        memberCount: 0
      },
      fubGroupsLoading: false
    },
    isBalanceListModalOpen: false
  }
};
export var rootReducer = createReducer(initialState, (_createReducer = {}, _defineProperty(_createReducer, ActionCreator.fetchAccounts.pending.type, function (state) {
  state.accounts.pending = true;
}), _defineProperty(_createReducer, ActionCreator.fetchAccounts.fulfilled.type, function (state, action) {
  state.accounts.pending = false;
  state.accounts.error = false;
  state.accounts.data = action.payload;
}), _defineProperty(_createReducer, ActionCreator.fetchAccounts.rejected.type, function (state) {
  state.accounts.pending = false;
  state.accounts.error = true;
}), _defineProperty(_createReducer, ActionCreator.updateAccountsList.type, function (state, action) {
  state.accounts.data = action.payload;
}), _defineProperty(_createReducer, ActionCreator.fetchInitData.pending.type, function (state) {
  state.initData.pending = true;
}), _defineProperty(_createReducer, ActionCreator.fetchInitData.fulfilled.type, function (state, action) {
  state.initData.pending = false;
  state.initData.data = action.payload;
}), _defineProperty(_createReducer, ActionCreator.fetchInitData.rejected.type, function (state) {
  state.initData.error = true;
}), _defineProperty(_createReducer, ActionCreator.fetchCommonData.pending.type, function (state) {
  state.commonData.pending = true;
}), _defineProperty(_createReducer, ActionCreator.fetchCommonData.fulfilled.type, function (state, action) {
  state.commonData.pending = false;
  state.commonData.data = action.payload;
}), _defineProperty(_createReducer, ActionCreator.fetchCommonData.rejected.type, function (state) {
  state.commonData.error = true;
}), _defineProperty(_createReducer, ActionCreator.fetchNotAuthData.pending.type, function (state) {
  state.notAuthData.pending = true;
  state.notAuthData.error = false;
}), _defineProperty(_createReducer, ActionCreator.fetchNotAuthData.fulfilled.type, function (state, action) {
  state.notAuthData.pending = false;
  state.notAuthData.error = false;
  state.notAuthData.data = action.payload;
}), _defineProperty(_createReducer, ActionCreator.fetchNotAuthData.rejected.type, function (state) {
  state.notAuthData.pending = false;
  state.notAuthData.error = true;
}), _defineProperty(_createReducer, ActionCreator.fetchNotifications.pending.type, function (state) {
  state.notifications.pending = true;
}), _defineProperty(_createReducer, ActionCreator.fetchNotifications.fulfilled.type, function (state, action) {
  state.notifications.pending = false;
  state.notifications.data = action.payload;
}), _defineProperty(_createReducer, ActionCreator.fetchNotifications.rejected.type, function (state) {
  state.notifications.pending = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchMobileConnection.pending.type, function (state) {
  state.connectionBlock.mobile.pending = true;
  state.connectionBlock.mobile.error = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchMobileConnection.fulfilled.type, function (state, action) {
  state.connectionBlock.mobile.pending = false;
  state.connectionBlock.mobile.error = false;
  state.connectionBlock.mobile.data = action.payload;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchMobileConnection.rejected.type, function (state) {
  state.connectionBlock.mobile.pending = false;
  state.connectionBlock.mobile.error = true;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionPower.pending.type, function (state) {
  state.connectionBlock.mobile.power.pending = true;
  state.connectionBlock.mobile.power.error = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionPower.fulfilled.type, function (state, action) {
  state.connectionBlock.mobile.power.pending = false;
  state.connectionBlock.mobile.power.error = false;
  state.connectionBlock.mobile.power.data = action.payload;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionPower.rejected.type, function (state) {
  state.connectionBlock.mobile.power.pending = false;
  state.connectionBlock.mobile.power.error = true;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionSuperPower.pending.type, function (state) {
  state.connectionBlock.mobile.superPower.pending = true;
  state.connectionBlock.mobile.superPower.error = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionSuperPower.fulfilled.type, function (state, action) {
  state.connectionBlock.mobile.superPower.pending = false;
  state.connectionBlock.mobile.superPower.error = false;
  state.connectionBlock.mobile.superPower.data = action.payload;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionSuperPower.rejected.type, function (state) {
  state.connectionBlock.mobile.superPower.pending = false;
  state.connectionBlock.mobile.superPower.error = true;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionPrice.pending.type, function (state) {
  state.connectionBlock.mobile.price.pending = true;
  state.connectionBlock.mobile.price.error = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionPrice.fulfilled.type, function (state, action) {
  state.connectionBlock.mobile.price.pending = false;
  state.connectionBlock.mobile.price.data = action.payload;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConnectionPrice.rejected.type, function (state) {
  state.connectionBlock.mobile.price.error = true;
  state.connectionBlock.mobile.price.pending = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchBalances.pending.type, function (state) {
  state.uniBalance.error = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchBalances.fulfilled.type, function (state, action) {
  if (action.payload.status === PAYLOAD_STATUS_DICTIONARY.SUCCESS) {
    state.uniBalance.error = false;
    state.uniBalance.balanceList = getExtendedBalanceList(action.payload.data.balanceList);
  } else {
    state.uniBalance.error = true;
  }
  state.uniBalance.pending = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchBalances.rejected.type, function (state) {
  state.uniBalance.pending = false;
  state.uniBalance.error = true;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchFubGroups.pending.type, function (state) {
  state.uniBalance.fubGroupsInfo.fubGroupsLoading = true;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchFubGroups.fulfilled.type, function (state, action) {
  var _action$payload$data;
  if (action.payload.status === PAYLOAD_STATUS_DICTIONARY.SUCCESS && (_action$payload$data = action.payload.data) !== null && _action$payload$data !== void 0 && _action$payload$data.currentStatus) {
    state.uniBalance.fubGroupsInfo.data = action.payload.data;
  }
  state.uniBalance.fubGroupsInfo.fubGroupsLoading = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchFubGroups.rejected.type, function (state) {
  state.uniBalance.fubGroupsInfo.fubGroupsLoading = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.toggleBalanceListModal.type, function (state, action) {
  state.uniBalance.isBalanceListModalOpen = action.payload;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchFTTBConnection.pending.type, function (state) {
  state.connectionBlock.fttb.pending = true;
  state.connectionBlock.fttb.error = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchFTTBConnection.fulfilled.type, function (state, action) {
  state.connectionBlock.fttb.pending = false;
  state.connectionBlock.fttb.error = false;
  state.connectionBlock.fttb.data = action.payload;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchFTTBConnection.rejected.type, function (state) {
  state.connectionBlock.fttb.pending = false;
  state.connectionBlock.fttb.error = true;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConvergent.pending.type, function (state) {
  state.connectionBlock.convergent.pending = true;
  state.connectionBlock.convergent.error = false;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConvergent.fulfilled.type, function (state, action) {
  state.connectionBlock.convergent.pending = false;
  state.connectionBlock.convergent.error = false;
  state.connectionBlock.convergent.data = action.payload;
}), _defineProperty(_createReducer, ConnectionBlockActionCreator.fetchConvergent.rejected.type, function (state) {
  state.connectionBlock.convergent.pending = false;
  state.connectionBlock.convergent.error = true;
}), _createReducer));